module.exports = {"title":["순차","반복","선택","변수"],"desc":[["소프트웨어 세상을 여행하려면 명령어 블록을 위에서부터 차례차례 실행해야 해!","이렇게 명령을 차례차례 실행하는 모양을 '순차' 구조라고 부른다는 사실 꼭 기억해 줘!"],["앞으로 이동하고, 앞으로 이동하고, 앞으로 이동하고... 무언가 더 편한 방법이 없을까?","계속 같은 행동을 되풀이해야 한다면 '반복' 구조를 사용해 더욱 쉽게 움직일 수 있어!"],["만약 앞에 아이템이 있다면? 또는 없다면? 이렇게 상황에 따라 행동하려면 어떻게 해야 할까?","주어진 조건에 따라 각각 다른 행동을 하려면 '선택' 구조의 도움을 받아 보는 게 어때?"],["앞에 사과가 하나, 둘, 세 개... 이번에는 배가 하나, 두 개... 아차! 사과가 모두 몇 개였지?","처리가 필요하거나 기억이 필요한 자료를 따로 '변수'에 저장해두면 훨씬 편리하겠는걸?"]]}


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = jIve
// module chunks = 4